import { ErrorBoundary } from '../src/components/ErrorBoundary'
import LandingPage from '../src/pages/LandingPage'

export default function Home() {
  return (
    <ErrorBoundary>
      <LandingPage />
    </ErrorBoundary>
  )
}